import Vue from 'vue';
import Constants from "@/plugins/constants";
const moment = require('moment')
require('moment/locale/es')

Vue.filter('period', function (value) {
    let period = Constants.periodOptions.find(period => period.value === value);
    if (period)
        return period.name;
    else
        return '';
});

Vue.filter('parallel', function (value) {
    let parallel = Constants.parallelOptions.find(parallel => parallel.value === value);
    return parallel.name;
});

Vue.filter('parallel_list', function (value) {
    if (value == 'NONE')
        return '';
    return '(' + value + ')';
});
Vue.filter('type_of_course', function (value) {
    let type_of_course = Constants.typeOfCourseOptions.find(type_of_course => type_of_course.value === value);
    return type_of_course.name;
});

Vue.filter('time_courses_offered', function (value) {
    let cousersRSI = ["REGULAR", "SEMI_INTENSIVE", "INTENSIVE"];
    let schedule = "";
    if (value.courses_offered_type_of_course) {
        let type_of_course = value.courses_offered_type_of_course;

        if (cousersRSI.includes(type_of_course)) {
            let start_time = value.courses_offered_monday_start_time;
            let finish_time = value.courses_offered_monday_finish_time;
            schedule = `Lunes a Viernes ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'PROFESSIONAL') {
            let start_time = value.courses_offered_saturday_start_time;
            let finish_time = value.courses_offered_saturday_finish_time;
            schedule = `Sábado ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'SPECIAL') {
            schedule = (value.courses_offered_monday_start_time && value.courses_offered_monday_finish_time) ? `Lunes \t\t${value.courses_offered_monday_start_time} - ${value.courses_offered_monday_finish_time}\n` : '';
            schedule += (value.courses_offered_tuesday_start_time && value.courses_offered_tuesday_finish_time) ? `Martes \t\t${value.courses_offered_tuesday_start_time} - ${value.courses_offered_tuesday_finish_time}\n` : '';
            schedule += (value.courses_offered_wednesday_start_time && value.courses_offered_wednesday_finish_time) ? `Miércoles \t${value.courses_offered_wednesday_start_time} - ${value.courses_offered_wednesday_finish_time}\n` : '';
            schedule += (value.courses_offered_thursday_start_time && value.courses_offered_thursday_finish_time) ? `Jueves \t\t${value.courses_offered_thursday_start_time} - ${value.courses_offered_thursday_finish_time}\n` : '';
            schedule += (value.courses_offered_friday_start_time && value.courses_offered_friday_finish_time) ? `Viernes \t\t${value.courses_offered_friday_start_time} - ${value.courses_offered_friday_finish_time}\n` : '';
            schedule += (value.courses_offered_saturday_start_time && value.courses_offered_saturday_finish_time) ? `Sábado \t\t${value.courses_offered_saturday_start_time} - ${value.courses_offered_saturday_finish_time}\n` : '';
        }

    } else {
        let type_of_course = value.type_of_course;

        if (cousersRSI.includes(type_of_course)) {
            let start_time = value.monday_start_time;
            let finish_time = value.monday_finish_time;
            schedule = `Lunes a Viernes ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'PROFESSIONAL') {
            let start_time = value.saturday_start_time;
            let finish_time = value.saturday_finish_time;
            schedule = `Sábado ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'SPECIAL') {
            schedule = (value.monday_start_time && value.monday_finish_time) ? `Lunes \t\t${value.monday_start_time} - ${value.monday_finish_time}\n` : '';
            schedule += (value.tuesday_start_time && value.tuesday_finish_time) ? `Martes \t\t${value.tuesday_start_time} - ${value.tuesday_finish_time}\n` : '';
            schedule += (value.wednesday_start_time && value.wednesday_finish_time) ? `Miércoles \t${value.wednesday_start_time} - ${value.wednesday_finish_time}\n` : '';
            schedule += (value.thursday_start_time && value.thursday_finish_time) ? `Jueves \t\t${value.thursday_start_time} - ${value.thursday_finish_time}\n` : '';
            schedule += (value.friday_start_time && value.friday_finish_time) ? `Viernes \t\t${value.friday_start_time} - ${value.friday_finish_time}\n` : '';
            schedule += (value.saturday_start_time && value.saturday_finish_time) ? `Sábado \t\t${value.saturday_start_time} - ${value.saturday_finish_time}\n` : '';
        }
    }
    return schedule;
});

Vue.filter('schedule', function (value) {
    let cousersRSI = ["REGULAR", "SEMI_INTENSIVE", "INTENSIVE"];
    let schedule = "";

    if (value.type_of_course) {
        let type_of_course = value.type_of_course;

        if (cousersRSI.includes(type_of_course)) {
            let start_time = value.monday_start_time;
            let finish_time = value.monday_finish_time;
            schedule = `Lunes a Viernes ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'PROFESSIONAL') {
            let start_time = value.saturday_start_time;
            let finish_time = value.saturday_finish_time;
            schedule = `Sábado ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'SPECIAL') {
            schedule = (value.monday_start_time && value.monday_finish_time) ? `Lunes \t\t${value.monday_start_time} - ${value.monday_finish_time}\n` : '';
            schedule += (value.tuesday_start_time && value.tuesday_finish_time) ? `Martes \t\t${value.tuesday_start_time} - ${value.tuesday_finish_time}\n` : '';
            schedule += (value.wednesday_start_time && value.wednesday_finish_time) ? `Miércoles \t${value.wednesday_start_time} - ${value.wednesday_finish_time}\n` : '';
            schedule += (value.thursday_start_time && value.thursday_finish_time) ? `Jueves \t\t${value.thursday_start_time} - ${value.thursday_finish_time}\n` : '';
            schedule += (value.friday_start_time && value.friday_finish_time) ? `Viernes \t\t${value.friday_start_time} - ${value.friday_finish_time}\n` : '';
            schedule += (value.saturday_start_time && value.saturday_finish_time) ? `Sábado \t\t${value.saturday_start_time} - ${value.saturday_finish_time}\n` : '';
        }

    } else {
        let type_of_course = value.type_of_course;

        if (cousersRSI.includes(type_of_course)) {
            let start_time = value.monday_start_time;
            let finish_time = value.monday_finish_time;
            schedule = `Lunes a Viernes ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'PROFESSIONAL') {
            let start_time = value.saturday_start_time;
            let finish_time = value.saturday_finish_time;
            schedule = `Sábado ${start_time} - ${finish_time}`;
        }
        if (type_of_course == 'SPECIAL') {
            schedule = (value.monday_start_time && value.monday_finish_time) ? `Lunes \t\t${value.monday_start_time} - ${value.monday_finish_time}\n` : '';
            schedule += (value.tuesday_start_time && value.tuesday_finish_time) ? `Martes \t\t${value.tuesday_start_time} - ${value.tuesday_finish_time}\n` : '';
            schedule += (value.wednesday_start_time && value.wednesday_finish_time) ? `Miércoles \t${value.wednesday_start_time} - ${value.wednesday_finish_time}\n` : '';
            schedule += (value.thursday_start_time && value.thursday_finish_time) ? `Jueves \t\t${value.thursday_start_time} - ${value.thursday_finish_time}\n` : '';
            schedule += (value.friday_start_time && value.friday_finish_time) ? `Viernes \t\t${value.friday_start_time} - ${value.friday_finish_time}\n` : '';
            schedule += (value.saturday_start_time && value.saturday_finish_time) ? `Sábado \t\t${value.saturday_start_time} - ${value.saturday_finish_time}\n` : '';
        }
    }
    return schedule;
});

Vue.filter('payment_method', function (value) {
    let payment_method = Constants.paymentMethodsOptions.find(payment_method => payment_method.value === value);
    return payment_method.name;
});

Vue.filter('date', (value, format, fs = 'DD-MM-YYYY') => {
    if (!value) return ''
    let date = moment(value, fs)
    return moment(date).format(format)
})

Vue.filter('other_sales', function (value) {
    if (value == true)
        return 'Otras ventas';
    return 'Pensión';
});